import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchMenu } from '../Menu/api';
import { useCallback, useMemo } from 'react';
import { MenuItem } from '~/types/Menu';

export const useMenu = () => {
  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['fetchMenu'],
    queryFn: fetchMenu,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return data;
};

export const useMenuItemById = () => {
  const menu = useMenu();

  return useMemo(() => {
    const itemById: Record<string, MenuItem> = {};
    menu.forEach(({ items }) => {
      items.forEach((item) => {
        itemById[item.id] = item;
      });
    });
    return itemById;
  }, [menu]);
};

export const useGetMenuItemPriceById = () => {
  const itemById = useMenuItemById();
  return useCallback(
    (id: string) => {
      return itemById[id].price;
    },
    [itemById]
  );
};
